import { actionTypes as FirebaseActions } from 'react-redux-firebase';

import { DEFAULT_CREATE_SEND_EMAIL_STATE } from '../../../constants/createSendEmail';
import { ICreateSendEmailState } from '../../../types/createSendEmail';
import * as AuthActions from '../../actions/auth';
import * as CreateSendEmailActions from '../actions/email';

export const initialState: ICreateSendEmailState = DEFAULT_CREATE_SEND_EMAIL_STATE;

const reducer = (state: ICreateSendEmailState = initialState, action: any): ICreateSendEmailState => {
  switch (action.type) {
    case AuthActions.ADMIN_ROLE_CHANGED:
    case AuthActions.CHANGE_ORGANIZATION_SUCCESS:
    case FirebaseActions.LOGOUT:
    case CreateSendEmailActions.RESET_CS_EMAIL: {
      return initialState;
    }
    case CreateSendEmailActions.INIT_CS_EMAIL: {
      const { emailTemplateId, subject, body } = action.payload;

      return { ...state, emailTemplateId, subject, body, initialized: true };
    }
    case CreateSendEmailActions.PATCH_CS_EMAIL: {
      return { ...state, ...action.payload };
    }
    case CreateSendEmailActions.PATCH_CS_EMAIL_REMINDER: {
      return { ...state, reminder: { ...state.reminder, ...action.payload } };
    }
    default:
      return state;
  }
};

export default reducer;
